import { MessagesType } from '@telialt/common-cms/src/model';
import { formatDataAmountWithUnits, withParams } from '@telialt/utils/src/helpers';

type Unlimited = -1;
type AllowanceValue = number | Unlimited | undefined;

const isUnlimitedAllowance = (value: AllowanceValue): value is Unlimited => {
    return value === -1;
};
const isLimitedAllowance = (value: AllowanceValue): value is number => {
    return !isUnlimitedAllowance(value) && value > 0;
};

type DataAllowanceUnit = 'TB' | 'GB' | 'MB' | 'KB' | 'B' | string;

export const formatCallsAndSmsAllowance = (minutes: AllowanceValue, sms: AllowanceValue, t: MessagesType) => {
    const isUnlimitedCalls = isUnlimitedAllowance(minutes);
    const isUnlimitedSms = isUnlimitedAllowance(sms);
    const isLimitedCalls = isLimitedAllowance(minutes);
    const isLimitedSms = isLimitedAllowance(sms);

    if (isUnlimitedCalls && isUnlimitedSms) {
        return t['eshop.order_cart.allowance.unlimited_voice_and_sms'];
    } else if (isUnlimitedCalls && isLimitedSms) {
        return withParams(t['eshop.order_cart.allowance.unlimited_voice_and_limited_sms'], { sms });
    } else if (isLimitedCalls && isUnlimitedSms) {
        return withParams(t['eshop.order_cart.allowance.limited_voice_and_unlimited_sms'], { minutes });
    } else if (isLimitedCalls && isLimitedSms) {
        return withParams(t['eshop.order_cart.allowance.limited_voice_and_sms'], { minutes, sms });
    } else {
        return t['eshop.order_cart.allowance.zero_voice_and_sms'];
    }
};

export const formatDataAllowance = (dataAllowance: AllowanceValue, unit: DataAllowanceUnit = 'GB', t: MessagesType) => {
    if (isUnlimitedAllowance(dataAllowance)) {
        return t['eshop.order_cart.allowance.unlimited_data_allowance'];
    } else if (isLimitedAllowance(dataAllowance)) {
        return formatDataAmountWithUnits(dataAllowance, unit);
    } else {
        return undefined;
    }
};
